import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { InformationCircleIcon as InformationCircleIconOutline } from '@heroicons/react/24/outline'
import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { MotionCollapse } from '@/components/shared/motion/MotionCollapse'

export const ValueDisclosure = ({ children }: { children: React.ReactNode }) => {
  return (
    <Disclosure as="div">
      {({ open }) => (
        <div
          className={
            // We could just use the plugin from https://headlessui.com/react/disclosure#using-data-attributes
            // But I didn't want to add another dependency just for this one time…
            open
              ? '**:data-[active-icon=closed]:hidden **:data-[active-icon=open]:block'
              : '**:data-[active-icon=closed]:block **:data-[active-icon=open]:hidden'
          }
        >
          {children}
        </div>
      )}
    </Disclosure>
  )
}

export const ValueDisclosureButton = ({
  children,
  hasBody,
}: {
  children: React.ReactNode
  /** @description use to hide the button conditionally */
  hasBody?: boolean
}) => {
  if (hasBody === false) return <div className="w-full min-w-0">{children}</div>

  return (
    <DisclosureButton className="group/button flex w-full min-w-0 cursor-pointer items-start gap-1 text-left">
      <div className="min-w-0 flex-1">{children}</div>
      <div className="focus-visible:ring-opacity-75 -my-px shrink-0 rounded border border-transparent bg-gray-50 text-left text-sm font-medium group-hover/button:border-gray-500 group-hover/button:bg-yellow-100 focus:outline-none focus-visible:ring focus-visible:ring-gray-500">
        <InformationCircleIcon
          data-active-icon="open" // see ValueDisclosure
          className="hidden size-4"
          title="Hinweise anzeigen…"
        />
        <InformationCircleIconOutline
          data-active-icon="closed" // see ValueDisclosure
          className="hidden size-4"
          title="Hinweise anzeigen…"
        />
      </div>
    </DisclosureButton>
  )
}

export const ValueDisclosurePanel = ({ children }: { children: React.ReactNode }) => {
  // `static` keeps the panel mounted so MotionCollapse can animate its height (0 ↔ auto),
  // smoothing the inspector resize instead of the previous instant height jump.
  return (
    <DisclosurePanel static>
      {({ open }) => (
        <MotionCollapse open={open}>
          <div className="mt-1 text-xs leading-tight [&>p]:mt-1 [&>p]:first:mt-0">{children}</div>
        </MotionCollapse>
      )}
    </DisclosurePanel>
  )
}
